import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import ImageCollage from "../../Assests/RebelSkool_Portal.webp";
import "./BusinessCentral.css";
import CMSTranslationFile from "../BusinessCentral/BusinessCentral_Translation_Corp.json";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";

let userSelectedLanguage;

class BusinessCentral extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    window.scrollTo(0, 0);
  }

  callback = () => {
    this.setState({
      reRender: true
    });
  };

  render() {
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <HeaderNavBar callBack={this.callback} />
        <div className="ID_BusinessCentral">
          <br></br>
          <br></br>
          <div
            style={{
              fontWeight: 500,
              // fontSize: "30px",
              textAlign: "center"
            }}
          >
            <strong>
              {" "}
              {CMSTranslationFile.MBCentral_Title[userSelectedLanguage]}
            </strong>
            {/* Business Central */}
          </div>
          <br></br>
          <section
            style={{
              // fontSize: "20px",
              textAlign: "left"
            }}
          >
            {CMSTranslationFile.MBCentral_Text1[userSelectedLanguage]}
            <a
              href={
                "mailto:" +
                "" +
                CMSTranslationFile.MBCentral_Link[userSelectedLanguage].replace(
                  /[()]/g,
                  ""
                )
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue" }}
            >
              {CMSTranslationFile.MBCentral_Link[userSelectedLanguage]}
            </a>
            {CMSTranslationFile.MBCentral_Text2[userSelectedLanguage]}
          </section>
          <br></br>
          <br></br>

          {/* <center>
            <img src={ImageCollage} height={1150} width={800} />
          </center> */}

          <div className="image-scroll-wrapper">
            <img src={ImageCollage} alt="Collage" />
          </div>
        </div>
        <ScrolltoTop />
        <Footer isCorpPortal={true} />
      </div>
    );
  }
}
export default BusinessCentral;
